import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MainService {
  constructor() {}
  private sharedData = new BehaviorSubject<any>(null);
  private sharedData2 = new BehaviorSubject<any>(null);
  private sharedData3 = new BehaviorSubject<any>(null);
  private sharedData4 = new BehaviorSubject<any>(null);
  private sharedData5 = new BehaviorSubject<any>(null);
  private sharedData6 = new BehaviorSubject<any>(null);
  sharedData$ = this.sharedData.asObservable();
  sharedData2$ = this.sharedData2.asObservable();
  sharedData3$ = this.sharedData3.asObservable();
  sharedData4$ = this.sharedData4.asObservable();
  sharedData5$ = this.sharedData4.asObservable();
  sharedData6$ = this.sharedData6.asObservable();
  setData(data: any) {
    console.log("data in service");
    this.sharedData.next(data);
  }
  getData() {
    console.log("data get");
    return this.sharedData.getValue();
  }
  setData2(data: any) {
    console.log("data in service");
    this.sharedData2.next(data);
  }
  getData2() {
    console.log("data get");
    return this.sharedData2.getValue();
  }
  setData3(data: any) {
    console.log("data in service");
    this.sharedData3.next(data);
  }
  getData3() {
    console.log("data get");
    return this.sharedData3.getValue();
  }
  setData4(data: any) {
    console.log(data, "data in service");
    this.sharedData4.next(data);
  }
  getData4() {
    console.log("data get");
    return this.sharedData4.getValue();
  }
  setData5(data: any) {
    console.log(data, "data in service");
    this.sharedData5.next(data);
  }
  getData5() {
    console.log("data get");
    return this.sharedData5.getValue();
  }
  setData6(data: any) {
    console.log(data, "data in service");
    this.sharedData6.next(data);
  }
  getData6() {
    console.log("data get");
    return this.sharedData6.getValue();
  }
}
